/**
 * Session Day Types
 */
export enum SessionDayType {
  First = '1st day',
  Consecutive = 'consecutive',
  NonConsecutive = 'non-consecutive',
  Saturday = 'Saturday',
  Sunday = 'Sunday',
  Holiday = 'Holiday',
}

/**
 * Holiday Types
 */
export enum HolidayType {
  NewYearsDay = "New Year's Day",
  MLKJrBirthday = "Martin Luther King Jr's Birthday",
  PresidentsDay = "President's Day",
  MemorialDay = 'Memorial Day',
  Juneteenth = 'Juneteenth',
  IndependenceDay = 'Independence Day',
  LaborDay = 'Labor Day',
  VeteransDay = "Veteran's Day",
  ThanksgivingDay = 'Thanksgiving Day',
  ChristmasDay = 'Christmas Day',
}

/**
 * Holidays
 */
export type HolidayDates = {
  [month: number]: {
    name: string;
    day?: number;
    days?: number[];
    weekday?: number;
  }[];
};

export const holidayDates: HolidayDates = {
  1: [
    { name: HolidayType.NewYearsDay, day: 1 },
    {
      name: HolidayType.MLKJrBirthday,
      weekday: 1, // [just another] floating monday
      days: [15, 21],
    },
  ],
  2: [
    {
      name: HolidayType.PresidentsDay,
      weekday: 1,
      days: [15, 21],
    },
  ],
  5: [
    {
      name: HolidayType.MemorialDay,
      weekday: 1,
      days: [25, 31],
    },
  ],
  7: [
    {
      name: HolidayType.IndependenceDay,
      day: 4,
    },
  ],
  9: [
    {
      name: HolidayType.LaborDay,
      weekday: 1,
      days: [1, 7],
    },
  ],
  11: [
    {
      name: HolidayType.VeteransDay,
      day: 11,
    },
    {
      name: HolidayType.ThanksgivingDay,
      weekday: 4, // [just another] floating thursday
      days: [22, 28],
    },
  ],
  12: [
    {
      name: HolidayType.ChristmasDay,
      day: 25,
    },
  ],
};
